var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import DataForm from "~/components/common/data-form.vue";
import DataBox from "~/components/common/data-box.vue";
import AssistCaseAllot from "~/components/case-info/assist-case-allot.vue";
import VisitManageFinish from "~/components/assistant-manage/visit-manage/visit-manage-finish.vue";
import VisitDoEnd from "~/components/assistant-manage/visit-manage/visit-do-end.vue";
import VisitManageVisiting from "~/components/assistant-manage/visit-manage/visit-manage-visiting.vue";
import VisitManageArray from "~/components/assistant-manage/visit-manage/visit-manage-array.vue";
import VisitCancel from "~/components/assistant-manage/visit-manage/visit-cancel.vue";
import VisitManageOutvisit from "~/components/assistant-manage/visit-manage/visit-manage-outvisit.vue";
import FollowRecord from "~/components/approval-manage/follow-record.vue";
import ProcessApprove from "~/components/assistant-manage/process-approve.vue";
import BatchApprove from "~/components/assistant-manage/batch-approve.vue";
import PrincipalBatch from "~/components/common-business/principal-batch.vue";
var VisitManage = /** @class */ (function (_super) {
    __extends(VisitManage, _super);
    function VisitManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.visitModel = {
            principalName: "",
            personalName: "",
            certificateNo: "",
            applyRealName: "",
            batchNumber: "",
            caseNumber: "",
            currentCollector: "",
            addressDetail: "",
            applyDate: [],
        };
        _this.approvalCommitLoading = false;
        // 默认激活页面
        _this.activeName = "outvisit-info";
        _this.approvalRules = {
            result: [
                {
                    required: true,
                    message: "请选择审批结果",
                    trigger: "change",
                },
            ],
        };
        _this.selectionList = [];
        _this.assistDataSet = null;
        _this.assistObj = {};
        _this.visitRowData = {};
        _this.dialog = {
            approvedialog: false,
            assistCaseAllot: false,
            batchApproveDialog: false,
        };
        _this.rules = {
            certificateNo: [
                {
                    min: 4,
                    message: "请输入至少4位的身份证号",
                    trigger: "blur",
                },
            ],
        };
        return _this;
    }
    VisitManage.prototype.deactivated = function () {
        for (var v in this.dialog) {
            this.dialog[v] = false;
        }
    };
    VisitManage.prototype.mounted = function () {
        this.refreshData();
    };
    //切换tab页面刷新对应的页面
    VisitManage.prototype.handleTabClick = function (tab, event) {
        this.activeName = tab.name;
        this.selectionList = [];
        this.resetSearchFelid();
        this.refreshData();
    };
    //刷新数据
    VisitManage.prototype.refreshData = function () {
        var tabdom = this.$refs[this.activeName];
        if (tabdom) {
            tabdom.refreshData();
        }
    };
    //弹出框
    VisitManage.prototype.approvedMeth = function (rowdata) {
        this.dialog.approvedialog = true;
        this.visitRowData = rowdata;
    };
    VisitManage.prototype.batchApproved = function (value) {
        this.validSectionList(value);
        if (this.selectionList.length === 0)
            return;
        this.dialog.batchApproveDialog = true;
    };
    VisitManage.prototype.validSectionList = function (value) {
        var component = this.$refs[value];
        if (component.selectionList.length === 0) {
            this.$message.info("请勾选列表中要审批的数据!");
            return;
        }
        this.selectionList = component.selectionList;
    };
    // 外访分配
    VisitManage.prototype.onForeignVisits = function (value) {
        this.validSectionList(value);
        if (this.selectionList.length === 0)
            return;
        this.dialog.assistCaseAllot = true;
    };
    VisitManage.prototype.onUserCaseAllotOpen = function () {
        var _this = this;
        this.$nextTick(function () {
            var form = _this.$refs["assist-case-allot"];
            form.refreshData();
        });
    };
    VisitManage.prototype.handleResetForm = function () {
        this.visitModel.principalId = "";
    };
    //reset搜索框条件
    VisitManage.prototype.resetSearchFelid = function () {
        this.visitModel = {
            principalName: "",
            personalName: "",
            certificateNo: "",
            applyRealName: "",
            batchNumber: "",
            currentCollector: "",
            applyDate: [],
            addressDetail: "",
            principalId: "",
        };
    };
    __decorate([
        Dependencies(PageService)
    ], VisitManage.prototype, "pageService", void 0);
    VisitManage = __decorate([
        Layout("workspace"),
        Component({
            components: {
                FollowRecord: FollowRecord,
                DataForm: DataForm,
                DataBox: DataBox,
                AssistCaseAllot: AssistCaseAllot,
                VisitManageFinish: VisitManageFinish,
                VisitManageVisiting: VisitManageVisiting,
                VisitManageOutvisit: VisitManageOutvisit,
                VisitManageArray: VisitManageArray,
                ProcessApprove: ProcessApprove,
                VisitDoEnd: VisitDoEnd,
                BatchApprove: BatchApprove,
                PrincipalBatch: PrincipalBatch,
                VisitCancel: VisitCancel,
            },
        })
    ], VisitManage);
    return VisitManage;
}(Vue));
export default VisitManage;
